import React from "react";
// import salesAnalyticsImg from "./TotalAssetWorth.png";
// import ordersFromImg from "./OrderFrom.png";
// import NumberCategoryImg from "./NoOfCategories.png";
// import inventoryTurnoverImg from "./InventoryTurnover.png";
import NavBar from "../NavBar";
import CardRender from "../DashboardCardRender";
import DashboardTablesRender from "../DashboardTablesRender";
import { InventoryCardData } from "../Dashboard card data";
import {
  INVENTORYDBInOutTableData,
  INVENTORYDBSupplierTableData,
} from "../DashboardTablesData";
import { Button } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SingleLineChart from "../SingleLineChart";
import BarLineChart from "../BarLineChart";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import StackedBarChart from '../StackedBarChart'
import OnlyLineChart from "../OnlyLineChart";
import InventoryTable1 from "./components/InventoryTable1";
import InventoryTable2 from "./components/InventoryTable2";
import DotsComponent from "../DotsComponent";
import { inventoryBarData1 } from "../BarchartData";
import { inventoryColorData1 } from "../BarColorData";
import {inventoryLineData1, inventoryLineData2, inventoryLineData3} from '../SingleLineChartData'
import { margin } from "@mui/system";
import GraphLabel2 from "../Components/GraphLabel2";
import GraphLabel1 from "../Components/GraphLabel1";
import GraphLabel3 from "../Components/GraphLabel3";

export default function InventoryDashboard() {
  return (
   
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Inventory Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Dashboard</h2>
        <div id="Right-content-Down-Filters">
          <Button variant="contained" startIcon={<AddCircleOutlineIcon />}>
            Create category
          </Button>
          <Button variant="contained" startIcon={<AddCircleOutlineIcon />}>
            Add a product
          </Button>
          <p>Till Now:</p>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <div
            style={{
              "border-left": "1px solid rgba(128, 128, 128, 0.511)",
              height: "80%",
            }}
          ></div>
          <label htmlFor="Starting-month">Sort from:</label>
          <input type="date" id="Starting-month" />
          <label htmlFor="Ending-month">To:</label>
          <input type="date" placeholder="Ending month" id="Ending-month" />
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>
      <div id="right-content-cards">
        <CardRender comp={InventoryCardData} />
      </div>

      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">TOTAL ASSET WORTH</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel1 color={"#527DFF"} 
            value={'Total worth'}
            />
          <SingleLineChart data={inventoryLineData1}/>
        </div>

        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">ORDERS FROM</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel3 color={["#394A7E","#4E6DCB", "#20BF55"]} 
            value={['Amazon', 'Shopify','Flipkart']}
          /> 
          <StackedBarChart BarData={inventoryBarData1} ColorData={inventoryColorData1}/>
        </div>
      </div>

      {/* Here I rendered the dashboard table1 */}

      {/* <DashboardTablesRender table1Name={INVENTORYDBSupplierTableData} /> */}
      <InventoryTable1/>
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">NUMBER OF CATEGORIES</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <SingleLineChart data={inventoryLineData2}/>
        </div>
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">INVENTORY TURNOVER</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <SingleLineChart data={inventoryLineData3} />
        </div>
      </div>
      <InventoryTable2 />
    </>
  );
}
